var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
import React from 'react';
import styled, { css } from 'styled-components';
import { breakpoints, theme } from '@shapeable/theme';
import { classNames, entityTypeNameFor } from '@shapeable/utils';
import { PersonCardMeta } from './person-card-meta';
import { Badge } from '../elements/badge';
import { CellHeader } from '../elements/cell-header';
import { EntityBubbleImage } from './entity-bubble-image';
import { ContentNode } from './content-node';
import { useComponentProps } from '../context/component-props-context';
import { usePageEntity } from '../hooks/use-page-entity';
import { sliceFontTypes } from '../utils/slice-font-types';
var cls = classNames('slice-organisation-banner');
export var SliceOrganisationBannerDefaultProps = {
  colorStripSize: 4
};
// -------- Styles -------->
var ContainerStyles = breakpoints({
  base: css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    font-size: ", ";\n    padding: ", " ", " ", ";\n    font-weight: 300;\n    \n    \n    ", "\n  "], ["\n    font-size: ", ";\n    padding: ", " ", " ", ";\n    font-weight: 300;\n    \n    \n    ", "\n  "])), theme.FONT_SIZE(14), theme.UNIT(2), theme.UNIT(3), theme.UNIT(3), function (_a) {
    var colorStripSize = _a.colorStripSize,
      colorStripColor = _a.colorStripColor;
    return css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n      background: ", ";\n      border-top: ", "px solid ", ";\n    "], ["\n      background: ", ";\n      border-top: ", "px solid ", ";\n    "])), theme.COLOR('app-chrome'), colorStripSize, theme.COLOR(colorStripColor));
  }),
  desktop: css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    font-size: ", ";\n  "], ["\n    font-size: ", ";\n  "])), theme.FONT_SIZE(16)),
  desktopDevice: css(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    padding: ", " ", " ", ";\n    border-radius: 0 0 ", " ", ";\n  "], ["\n    padding: ", " ", " ", ";\n    border-radius: 0 0 ", " ", ";\n  "])), theme.UNIT(3), theme.UNIT(5), theme.UNIT(6), theme.UNIT(3), theme.UNIT(3))
});
var BodyStyles = breakpoints({
  base: css(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    justify-content: space-between;\n  "], ["\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    justify-content: space-between;\n  "])))
});
var MetaStyles = breakpoints({
  base: css(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n    font-size: 1em;\n    font-weight: 300;\n    margin-bottom: ", ";\n  "], ["\n    font-size: 1em;\n    font-weight: 300;\n    margin-bottom: ", ";\n  "])), theme.UNIT(2))
});
var TitlesStyles = breakpoints({
  base: css(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n    ", ";\n\n    font-weight: 400;\n\n    h1 {\n      margin: 0;\n      padding: 0;\n      font-size: 2.5em;\n    }\n\n    b, strong {\n      font-weight: 500;\n    }\n  "], ["\n    ", ";\n\n    font-weight: 400;\n\n    h1 {\n      margin: 0;\n      padding: 0;\n      font-size: 2.5em;\n    }\n\n    b, strong {\n      font-weight: 500;\n    }\n  "])), theme.APPLY_FONTS)
});
var LabelAndBadgesStyles = breakpoints({
  base: css(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n    display: flex;\n    gap: ", ";\n  "], ["\n    display: flex;\n    gap: ", ";\n  "])), theme.UNIT(2))
});
var LabelStyles = breakpoints({
  base: css(templateObject_9 || (templateObject_9 = __makeTemplateObject(["\n    display: flex;\n    color: ", ";\n    padding-bottom: ", ";\n  "], ["\n    display: flex;\n    color: ", ";\n    padding-bottom: ", ";\n  "])), theme.COLOR('mid'), theme.UNIT(2)),
  tablet: css(templateObject_10 || (templateObject_10 = __makeTemplateObject(["\n    \n  "], ["\n    \n  "])))
});
var ImageStyles = breakpoints({
  base: css(templateObject_11 || (templateObject_11 = __makeTemplateObject(["\n  "], ["\n  "])))
});
var InfoStyles = breakpoints({
  base: css(templateObject_12 || (templateObject_12 = __makeTemplateObject(["\n    display: flex;\n    flex-direction: column;\n    align-items: flex-start;\n    padding-right: ", ";\n  "], ["\n    display: flex;\n    flex-direction: column;\n    align-items: flex-start;\n    padding-right: ", ";\n  "])), theme.UNIT(4))
});
var SpotlightBadgeStyles = breakpoints({
  base: css(templateObject_13 || (templateObject_13 = __makeTemplateObject(["\n    \n  "], ["\n    \n  "])))
});
// -------- Components -------->
var My = {
  NAME: 'SliceOrganisationBanner',
  Container: styled.div(templateObject_14 || (templateObject_14 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  LabelAndBadges: styled.div(templateObject_15 || (templateObject_15 = __makeTemplateObject(["", ""], ["", ""])), LabelAndBadgesStyles),
  Label: styled(CellHeader)(templateObject_16 || (templateObject_16 = __makeTemplateObject(["", ""], ["", ""])), LabelStyles),
  Body: styled.div(templateObject_17 || (templateObject_17 = __makeTemplateObject(["", ""], ["", ""])), BodyStyles),
  Info: styled.div(templateObject_18 || (templateObject_18 = __makeTemplateObject(["", ""], ["", ""])), InfoStyles),
  Titles: styled(ContentNode)(templateObject_19 || (templateObject_19 = __makeTemplateObject(["", ""], ["", ""])), TitlesStyles),
  Meta: styled(PersonCardMeta)(templateObject_20 || (templateObject_20 = __makeTemplateObject(["", ""], ["", ""])), MetaStyles),
  SpotlightBadge: styled(Badge)(templateObject_21 || (templateObject_21 = __makeTemplateObject(["", ""], ["", ""])), SpotlightBadgeStyles),
  Image: styled(EntityBubbleImage)(templateObject_22 || (templateObject_22 = __makeTemplateObject(["", ""], ["", ""])), ImageStyles)
};
export var SliceOrganisationBanner = function (props) {
  var _a, _b, _c;
  var componentProps = useComponentProps(My.NAME, SliceOrganisationBannerDefaultProps, props);
  var className = componentProps.className,
    children = componentProps.children,
    entity = componentProps.entity,
    colorStripSize = componentProps.colorStripSize;
  var fontTypes = sliceFontTypes(entity);
  var sliceLabel = entity.label,
    content = entity.content;
  var activeEntity = usePageEntity();
  var orgType = (_a = activeEntity === null || activeEntity === void 0 ? void 0 : activeEntity.type) === null || _a === void 0 ? void 0 : _a.name;
  var label = entityTypeNameFor(activeEntity) || sliceLabel;
  var hasBadge = !!(activeEntity === null || activeEntity === void 0 ? void 0 : activeEntity.badge);
  var colorStripColor = (_b = entity === null || entity === void 0 ? void 0 : entity.color) === null || _b === void 0 ? void 0 : _b.value;
  var showColorStrip = props.showColorStrip === undefined ? !!((_c = entity.color) === null || _c === void 0 ? void 0 : _c.value) : props.showColorStrip;
  return React.createElement(My.Container, {
    fontTypes: fontTypes,
    colorStripColor: colorStripColor,
    colorStripSize: showColorStrip ? colorStripSize : 0,
    className: cls.name(className)
  }, React.createElement(My.LabelAndBadges, null, !!label && React.createElement(My.Label, {
    badge: orgType
  }, label), hasBadge && React.createElement(My.SpotlightBadge, null, activeEntity.badge)), React.createElement(My.Body, null, React.createElement(My.Info, null, React.createElement(My.Titles, {
    fontTypes: sliceFontTypes(entity),
    entity: content
  })), React.createElement(My.Image, {
    size: 130,
    entity: activeEntity
  })), children);
};
SliceOrganisationBanner.defaultProps = SliceOrganisationBannerDefaultProps;
SliceOrganisationBanner.cls = cls;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11, templateObject_12, templateObject_13, templateObject_14, templateObject_15, templateObject_16, templateObject_17, templateObject_18, templateObject_19, templateObject_20, templateObject_21, templateObject_22;